import React, { FC } from 'react'
import { ImageListItem, ImageListItemProps } from '@mui/material'

const EvtImageListItem: FC<ImageListItemProps> = ({ children, ...props }) => {
    return <ImageListItem {...props}>{children}</ImageListItem>
}

export default EvtImageListItem
